import Footer from "./footer"
import Navbar from "./navbar"

type Props = {
  children: React.ReactNode
}

const Layout = ({ children }: Props) => {
  return (
    <div className="flex min-h-screen flex-col">
      <Navbar />
      <main className="mx-auto w-full max-w-2xl flex-1 px-5 pt-12 pb-24 md:pt-20">
        {children}
      </main>
      <Footer />
    </div>
  )
}

export default Layout
